<div class="SidePanelHeader__Label">
  <h6
    tabindex="0"
    [ngClass]="{ 'SidePanelHeader__Label--WithBorder': showBorder }"
    [innerHTML]="displayText"
  ></h6>
</div>
